import { render, staticRenderFns } from "./DetalhesTabelaFrete.vue?vue&type=template&id=186734d8"
import script from "./DetalhesTabelaFrete.vue?vue&type=script&lang=js"
export * from "./DetalhesTabelaFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports